import type { IconSvgObject } from './types';

const XingIcon: IconSvgObject = [
  ["path", { d: "M7 6H3L5 11L3 16H7L9 11L7 6Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 2H16L10 15L14 22H19L15 15L21 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default XingIcon;
